import { Text } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isExcluded: boolean;
};

export const IsExcludedText: FC<Props> = ({ isExcluded }) => {
  const { t } = useTranslation();

  return (
    <Text
      weight="regular"
      text={isExcluded ? t('is-excluded') : t('is-not-excluded')}
    />
  );
};
